import { ReactNode, useEffect, useState } from "react";
import type { DevSettings } from "../devSettings";
import { loadMockServerConfig } from "./mockServerConfig";
import { mockServerOrigin } from "./nativeTestVariant";

const CONFIG_URL = `${mockServerOrigin}/__config`;

interface NativeTestRootProps {
  readonly children: (settings: DevSettings) => ReactNode;
}

const NativeTestRoot = ({ children }: NativeTestRootProps) => {
  const [settings, setSettings] = useState<DevSettings>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    loadMockServerConfig({ url: CONFIG_URL, fetch: (url) => fetch(url) }).then(setSettings, setError);
  }, []);

  if (error) {
    throw error;
  }

  return settings ? children(settings) : null;
};

export { NativeTestRoot };
